import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import NewPasswordForm from '../set-new-password/form.container';
import TopNavBar from '../top-nav-bar.container';
import Alert from '../../components/alert';
import {
  ALERT_SET_NEW_PASSWORD_ERROR,
  unauthenticateUser,
} from '../../actions';
import {
  getCurrentUser,
} from '../../selectors/user-selector';

class SetNewPassword extends Component {
  componentWillMount() {
    if (this.props.currentUser) {
      this.props.unauthenticateUser();
    }
  }

  get email() {
    return this.params.email;
  }

  get token() {
    return this.params.token;
  }

  get redirectTo() {
    return this.params.redirect;
  }

  get requiresFullName() {
    return this.params.full_name === 'true';
  }

  get params() {
    return qs.parse(this.props.location.search.replace(/^\?/, ''));
  }

  renderAlert() {
    if (this.props.errorAlert) {
      return (
        <Alert type="danger">
          {this.props.errorAlert.content}
        </Alert>
      );
    }
  }

  render() {
    return (
      <div>
        <TopNavBar />
        { this.renderAlert() }
        <div className="row justify-content-center mt-4 pt-4">
          <div className="col-sm-12 col-md-4">
            <div className="card m-auto">
              <NewPasswordForm
                email={this.email}
                resetPasswordToken={this.token}
                redirectTo={this.redirectTo}
                askFullName={this.requiresFullName}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const currentUser = getCurrentUser(state);
  const { ui } = state;

  return {
    currentUser,
    errorAlert: ui.alerts[ALERT_SET_NEW_PASSWORD_ERROR],
  };
};

const mapDispatchToProps = {
  unauthenticateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(SetNewPassword);



// WEBPACK FOOTER //
// ./src/desktop/containers/set-new-password/index.container.js